export const PORTAL_LINK_BASE_PATH = '/portal-link'

export const PORTAL_LINK_BIDS_PATH = `${PORTAL_LINK_BASE_PATH}/bids`

export const PORTAL_LINK_TENDER_PATH = `${PORTAL_LINK_BASE_PATH}/tender`

export const PORTAL_LINK_SHIPMENTS_PATH = `${PORTAL_LINK_BASE_PATH}/shipments`
